import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import UserSelection from '../UserSelection';
import ServiceSelection from '../ServiceSelection';
import CrashRoute from 'app/pages/CrashRoute';

import { useDispatch, useSelector } from 'react-redux';
import { clearInternalNewRequest, setInternalNewRequest } from 'app/store/slices/forms';
import { CircularProgress, Grid, makeStyles } from '@material-ui/core';
import { URLS } from 'app/config/urls';
import { updateServiceDetails } from 'app/store/slices/services';

import styles from './styles';
import companyEndpoints from 'app/api/services/companyEndpoints';
import notification from 'app/config/notification';
import CompanySelection from '../CompanySelection';
import { USER_SECTORS } from '../../../../utils/constants';
const useStyles = makeStyles(styles);

const Selection = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { setOpenNewRequest, intl } = props;

  const [title, setTitle] = useState('Selecione a empresa');

  const finalStep = 2;
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const internalNewRequest = useSelector(state => state.forms.internalNewRequest);

  const user = useSelector(state => state.auth.user);
  const isDplo = useMemo(() => {
    return !user.setores ? null : user.setores.find((e) => USER_SECTORS.DQS_DPLO === e.cdOrgaoSetor);
  },[user]);

  const handleSubmit = async (type, cdData, obj) => {
    setLoading(true);
    const temp = { ...internalNewRequest };
    temp[type] = cdData;
    let goToCompanySelect = false;
    let actualStep = step;

    if (type === 'cdUsuario') {
      let companies = [];
      const companiesResponse = await companyEndpoints.getCompaniesByUser(cdData);

      if(companiesResponse.status === 200){
        companies = companiesResponse.data;
      }

      if(companies && companies.length > 1){
        temp['companies'] = companies;
        goToCompanySelect = true;
      } else if (obj?.cdEmpresaPadrao) {
        let response = await companyEndpoints.getCompany({ cdEmpresa: obj.cdEmpresaPadrao });

        if (response?.status !== 200 || !response?.data) {
          notification(intl.formatMessage({ id: 'MESSAGES.REQUEST.PROBLEM_GET_REQUESTS' }), {
            toastId: 'PROBLEM_GET_REQUESTS',
            type: 'error',
          });
          setLoading(false);
          return false;
        }
        temp['company'] = response.data;
      }
      temp['user'] = obj;

    } else if (type === 'company') {
      temp['company'] = obj;
      if(isDplo){
        temp['cdUsuario'] = user.username;
      }
      actualStep = 1;
    } else if (type === 'cdServico') {
      temp[type] = Number(temp[type])
      temp['servico'] = obj;
    }

    await dispatch(setInternalNewRequest(temp));

    let nextStep = actualStep + 1;
    if(goToCompanySelect){
      nextStep = 3
    } else if (nextStep > finalStep) {
      dispatch(updateServiceDetails(temp.servico || {}));
      history.push(URLS.NEW_REQUEST);
      setOpenNewRequest(false);
      return;
    }
    setStep(nextStep);
    setLoading(false);
  };

  const handleCancel = async (type, fromCompanySelect) => {
    if(fromCompanySelect){
      setStep(1);
    }
    const temp = { ...internalNewRequest };
    if (temp[type]) delete temp[type];
    await dispatch(setInternalNewRequest(temp));

    let nextStep = step - 1;
    if (nextStep < 1) {
      nextStep = 1;
      dispatch(clearInternalNewRequest());
      setOpenNewRequest(false);
    }
    setStep(nextStep);
  };

  const Component = useMemo(() => {
    switch (step) {
      case 1:
        setTitle('Selecione a empresa/pessoa');
        return UserSelection;
      case 2:
        setTitle('Selecione o serviço');
        return ServiceSelection;
      case 3:
        setTitle('Selecione a empresa');
        return CompanySelection;
      default:
        return CrashRoute;
    }
  }, [setTitle, step]);

  if (loading) {
    return (
      <Grid item xs={12} className={classes.centerProgress}>
        <CircularProgress size={16} />
      </Grid>
    );
  }

  return (
    <>
      <h3>{title}</h3>
      <Component
        {...props}
        classes={classes}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
      />
    </>
  );
};

export default injectIntl(Selection);
